import React from "react";

import ClosedLoopTree from "./ClosedLoopTree";

export default function ClosedLoopTreeIncoming() {
  const data = {
    name: "Incoming Transactions​",
    value: 500,
    id: 1,
    children: [
      {
        name: "Own Bank",
        id: 2,
        value: 100,
        parent: 500,
        children: [
          { name: "Rekening sendiri​", id: 3, value: 20, parent: 100 },
          {
            name: "Mitra Korporat​",
            value: 30,
            id: 4,
            parent: 100,
            children: [
              {
                name: "Customer 1",
                value: 11,
                id: 5,
                parent: 30,
                children: [
                  { name: "Payment", id: 6, value: 5, parent: 11 },
                  { name: "Transfer", id: 7, value: 6, parent: 11 },
                ],
              },
              { name: "Customer 2", id: 8, value: 19, parent: 30 },
            ],
          },
          {
            name: "Within group / Intracompany ​",
            id: 9,
            value: 20,
            parent: 100,
          },
          { name: "Unclassified", id: 10, value: 30, parent: 100 },
        ],
      },
      {
        name: "Other Banks",
        value: 200,
        parent: 500,
        id: 11,
        children: [
          {
            name: "Mitra Korporat​",
            value: 100,
            parent: 200,
            id: 12,
            children: [
              {
                name: "Customer 1",
                value: 90,
                id: 13,
                parent: 100,
                children: [{ name: "Transfer", id: 14, value: 90, parent: 90 }],
              },
              { name: "Customer 2", id: 15, value: 10, parent: 100 },
            ],
          },
          {
            name: "Within group / Intracompany",
            id: 16,
            value: 50,
            parent: 200,
          },
          { name: "Unclassified", id: 17, value: 50, parent: 200 },
        ],
      },
      {
        name: "Setor Tunai​",
        value: 200,
        id: 18,
        parent: 500,
      },
    ],
  };
  return <ClosedLoopTree data={data} />;
}
